'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'

import { Container, MenuLink } from '@/components'
import { infoPages } from '@/settings'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import { useGlobalStore } from '@/store/provider'

export function Footer() {
  const { setShowFeedback } = useGlobalStore((state) => state)

  const NavItem = ({ name, href }: { name: string, href: string }) => {
    return (
      <li className='py-0'>
        <MenuLink href={href} className='font-medium dark:font-light'>
          {name}
        </MenuLink>
      </li>
    )
  }

  const TM = () => {
    return <sup className='text-[7px] font-medium ml-0.5'>TM</sup>
  }
  return (
    <>
      <div className={
        twMerge(
          'min-h-[140px] lg:min-h-[100px]',
          'flex items-center justify-center',
          'bg-zinc-100/90 dark:bg-zinc-950 text-black dark:text-zinc-200'
        )
      }>
        <Container size='xl' className='flex flex-col lg:flex-row-reverse items-center justify-center gap-y-2 gap-x-18'>
          <ul className='flex flex-wrap justify-center font-normal dark:font-light text-sm md:-ml-2'>
            {
              _.map(infoPages, (page, idx) => <NavItem key={`infoPage_${idx}`} {...page} />)
            }
            <li className='lg:ml-8'>
              <button type='button' className='menu-button font-medium dark:font-light' onClick={() => setShowFeedback(true)}>
                <ChatBubbleLeftRightIcon className='size-5 mr-2' />
                Feedback
              </button>
            </li>
          </ul>
          <div className='flex gap-x-2 text-sm font-medium dark:font-light subpixel-antialiased'>
            <div>© 2024-{new Date().getFullYear()}</div>
            <div>Cruz<TM /></div>
          </div>
        </Container>
      </div>
    </>
  )
}